export const breakPoints = {
  mobile: `only screen and (max-width: 767px)`,
  ipad: `only screen and (min-width: 768px) and (max-width: 1024px)`,
  desktop: `only screen and (min-width: 1025px)`,
}



// WEBPACK FOOTER //
// ./src/shared/breakPoints.js